import { render } from "./HeroTab.vue?vue&type=template&id=487b8484&scoped=true"
import script from "./HeroTab.vue?vue&type=script&lang=js"
export * from "./HeroTab.vue?vue&type=script&lang=js"

import "./HeroTab.vue?vue&type=style&index=0&id=487b8484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487b8484"]])

export default __exports__